import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TomosSection() {
  return <section className="py-14 bg-brand-dark relative" data-id="element-411">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-412">
        <FadeIn data-id="element-413">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-10 text-center" data-id="element-414">
            LOS 5 TOMOS
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-415">
          {/* TOMO 1 */}
          <FadeIn delay={0.1} direction="up" data-id="element-416">
            <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 md:p-8 relative overflow-hidden group hover:border-blue-500/50 transition-colors" data-id="element-417">
              <div className="absolute left-0 top-0 bottom-0 w-2 bg-blue-500" data-id="element-418"></div>
              <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/5 rounded-full pointer-events-none group-hover:bg-blue-500/10 transition-colors" style={{
              filter: 'blur(40px)'
            }} data-id="element-419"></div>

              <div className="relative z-10" data-id="element-420">
                <div className="flex items-center gap-4 mb-4" data-id="element-421">
                  <span className="text-4xl" data-id="element-422">📘</span>
                  <div data-id="element-423">
                    <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-424">
                      TOMO 1 — El Diccionario de Errores
                    </h3>
                    <p className="text-blue-400 font-medium mt-1" data-id="element-425">
                      Xiaomi · Segway · Genéricos
                    </p>
                  </div>
                </div>

                <ul className="space-y-3 mt-6 text-zinc-300" data-id="element-426">
                  <li className="flex items-start gap-3" data-id="element-427">
                    <span className="text-blue-500 mt-1" data-id="element-428">▸</span>
                    <span data-id="element-429">
                      Cómo identificar qué significa cada código de error y cada
                      pitido sin buscar en Google.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-430">
                    <span className="text-blue-500 mt-1" data-id="element-431">▸</span>
                    <span data-id="element-432">
                      La tabla completa de todos los errores documentados para
                      los modelos más vendidos en Argentina.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-433">
                    <span className="text-blue-500 mt-1" data-id="element-434">▸</span>
                    <span data-id="element-435">
                      El protocolo de reset universal que resuelve el 40% de las
                      fallas sin herramientas.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-436">
                    <span className="text-blue-500 mt-1" data-id="element-437">▸</span>
                    <span data-id="element-438">
                      Paso a paso para aplicar desde el celular en la calle en 5
                      minutos.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>

          {/* TOMO 2 */}
          <FadeIn delay={0.2} direction="up" data-id="element-439">
            <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 md:p-8 relative overflow-hidden group hover:border-orange-500/50 transition-colors" data-id="element-440">
              <div className="absolute left-0 top-0 bottom-0 w-2 bg-orange-500" data-id="element-441"></div>
              <div className="absolute top-0 right-0 w-64 h-64 bg-orange-500/5 rounded-full pointer-events-none group-hover:bg-orange-500/10 transition-colors" style={{
              filter: 'blur(40px)'
            }} data-id="element-442"></div>

              <div className="relative z-10" data-id="element-443">
                <div className="flex items-center gap-4 mb-4" data-id="element-444">
                  <span className="text-4xl" data-id="element-445">📙</span>
                  <div data-id="element-446">
                    <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-447">
                      TOMO 2 — Protocolo Anti-Pinchazos
                    </h3>
                    <p className="text-orange-400 font-medium mt-1" data-id="element-448">
                      El Cambio de Rueda Motor
                    </p>
                  </div>
                </div>

                <ul className="space-y-3 mt-6 text-zinc-300" data-id="element-449">
                  <li className="flex items-start gap-3" data-id="element-450">
                    <span className="text-orange-500 mt-1" data-id="element-451">▸</span>
                    <span data-id="element-452">
                      La diferencia entre rueda neumática y sólida y qué
                      repuesto exacto necesitás.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-453">
                    <span className="text-orange-500 mt-1" data-id="element-454">▸</span>
                    <span data-id="element-455">
                      Los 12 pasos para cambiar la cámara sin romper el cable
                      del motor.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-456">
                    <span className="text-orange-500 mt-1" data-id="element-457">▸</span>
                    <span data-id="element-458">
                      El truco de la palanca para separar el neumático sin
                      herramientas de taller.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-459">
                    <span className="text-orange-500 mt-1" data-id="element-460">▸</span>
                    <span data-id="element-461">
                      Cómo conseguir el repuesto correcto en Argentina al menor
                      precio posible.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>

          {/* TOMO 3 */}
          <FadeIn delay={0.3} direction="up" data-id="element-462">
            <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 md:p-8 relative overflow-hidden group hover:border-green-500/50 transition-colors" data-id="element-463">
              <div className="absolute left-0 top-0 bottom-0 w-2 bg-green-500" data-id="element-464"></div>
              <div className="absolute top-0 right-0 w-64 h-64 bg-green-500/5 rounded-full pointer-events-none group-hover:bg-green-500/10 transition-colors" style={{
              filter: 'blur(40px)'
            }} data-id="element-465"></div>

              <div className="relative z-10" data-id="element-466">
                <div className="flex items-center gap-4 mb-4" data-id="element-467">
                  <span className="text-4xl" data-id="element-468">📗</span>
                  <div data-id="element-469">
                    <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-470">
                      TOMO 3 — Blindaje de Electrónica y Controladores
                    </h3>
                    <p className="text-green-400 font-medium mt-1" data-id="element-471">
                      Lluvia · Humedad · Cortocircuitos
                    </p>
                  </div>
                </div>

                <ul className="space-y-3 mt-6 text-zinc-300" data-id="element-472">
                  <li className="flex items-start gap-3" data-id="element-473">
                    <span className="text-green-500 mt-1" data-id="element-474">▸</span>
                    <span data-id="element-475">
                      Por qué el IPX4 de fábrica no protege tu monopatín después
                      de 6 meses.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-476">
                    <span className="text-green-500 mt-1" data-id="element-477">▸</span>
                    <span data-id="element-478">
                      Los 8 puntos críticos de entrada de agua que nadie te
                      muestra.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-479">
                    <span className="text-green-500 mt-1" data-id="element-480">▸</span>
                    <span data-id="element-481">
                      El protocolo completo de blindaje con materiales de
                      ferretería por menos de $3.000 ARS.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-482">
                    <span className="text-green-500 mt-1" data-id="element-483">▸</span>
                    <span data-id="element-484">
                      Qué hacer si el agua ya entró y necesitás rescatar la
                      electrónica.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>

          {/* TOMO 4 */}
          <FadeIn delay={0.4} direction="up" data-id="element-485">
            <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 md:p-8 relative overflow-hidden group hover:border-red-500/50 transition-colors" data-id="element-486">
              <div className="absolute left-0 top-0 bottom-0 w-2 bg-red-500" data-id="element-487"></div>
              <div className="absolute top-0 right-0 w-64 h-64 bg-red-500/5 rounded-full pointer-events-none group-hover:bg-red-500/10 transition-colors" style={{
              filter: 'blur(40px)'
            }} data-id="element-488"></div>

              <div className="relative z-10" data-id="element-489">
                <div className="flex items-center gap-4 mb-4" data-id="element-490">
                  <span className="text-4xl" data-id="element-491">📕</span>
                  <div data-id="element-492">
                    <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-493">
                      TOMO 4 — Ajuste de Holguras y Frenos de Emergencia
                    </h3>
                    <p className="text-red-400 font-medium mt-1" data-id="element-494">
                      Manubrio · Freno de Disco · Freno Electrónico
                    </p>
                  </div>
                </div>

                <ul className="space-y-3 mt-6 text-zinc-300" data-id="element-495">
                  <li className="flex items-start gap-3" data-id="element-496">
                    <span className="text-red-500 mt-1" data-id="element-497">▸</span>
                    <span data-id="element-498">
                      Los 4 tipos de holgura y el test de 60 segundos para
                      identificarlos.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-499">
                    <span className="text-red-500 mt-1" data-id="element-500">▸</span>
                    <span data-id="element-501">
                      El protocolo de ajuste del mecanismo de plegado en 5
                      minutos con una sola llave allen.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-502">
                    <span className="text-red-500 mt-1" data-id="element-503">▸</span>
                    <span data-id="element-504">
                      Cómo calibrar el freno de disco para que muerda en seco
                      sin ir al service.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-505">
                    <span className="text-red-500 mt-1" data-id="element-506">▸</span>
                    <span data-id="element-507">
                      Los 6 errores de frenado más comunes y cómo corregirlos.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>

          {/* TOMO 5 */}
          <FadeIn delay={0.5} direction="up" data-id="element-508">
            <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 md:p-8 relative overflow-hidden group hover:border-yellow-500/50 transition-colors" data-id="element-509">
              <div className="absolute left-0 top-0 bottom-0 w-2 bg-yellow-500" data-id="element-510"></div>
              <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-500/5 rounded-full pointer-events-none group-hover:bg-yellow-500/10 transition-colors" style={{
              filter: 'blur(40px)'
            }} data-id="element-511"></div>

              <div className="relative z-10" data-id="element-512">
                <div className="flex items-center gap-4 mb-4" data-id="element-513">
                  <span className="text-4xl" data-id="element-514">📒</span>
                  <div data-id="element-515">
                    <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-516">
                      TOMO 5 — Guía de Resucitación de Baterías
                    </h3>
                    <p className="text-yellow-400 font-medium mt-1" data-id="element-517">
                      Cuidado · Carga · Recuperación
                    </p>
                  </div>
                </div>

                <ul className="space-y-3 mt-6 text-zinc-300" data-id="element-518">
                  <li className="flex items-start gap-3" data-id="element-519">
                    <span className="text-yellow-500 mt-1" data-id="element-520">▸</span>
                    <span data-id="element-521">
                      Los 4 hábitos que matan la batería antes de tiempo y cómo
                      evitarlos.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-522">
                    <span className="text-yellow-500 mt-1" data-id="element-523">▸</span>
                    <span data-id="element-524">
                      El protocolo de carga correcta que duplica la vida útil de
                      las celdas.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-525">
                    <span className="text-yellow-500 mt-1" data-id="element-526">▸</span>
                    <span data-id="element-527">
                      Qué hacer cuando el cargador se pone verde inmediatamente
                      y el monopatín no enciende.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-528">
                    <span className="text-yellow-500 mt-1" data-id="element-529">▸</span>
                    <span data-id="element-530">
                      El protocolo de resucitación de 3 pasos para baterías
                      bloqueadas por almacenamiento incorrecto.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}